var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-status  " },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Cancellation",
            "ok-title": "Confirm"
          },
          on: { ok: _vm.clickConfirmCancel, hide: _vm.closeCancel },
          model: {
            value: _vm.showConfirmCancel,
            callback: function($$v) {
              _vm.showConfirmCancel = $$v
            },
            expression: "showConfirmCancel"
          }
        },
        [
          _c("p", [
            _vm._v("Please enter a reason for cancelling the social post:")
          ]),
          _vm._v(" "),
          _c("b-form-textarea", {
            attrs: { id: "textConfirmCancel-" + _vm.deliverable.id, rows: "3" },
            model: {
              value: _vm.textConfirmCancel,
              callback: function($$v) {
                _vm.textConfirmCancel = $$v
              },
              expression: "textConfirmCancel"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasTooltip
        ? _c(
            "b-tooltip",
            {
              attrs: {
                target: "social-status-label-" + _vm.deliverable.id,
                triggers: "hover"
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.deliverable.publish_notes) + "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "social-status-label",
          style: { background: _vm.statusColor },
          attrs: { id: "social-status-label-" + _vm.deliverable.id },
          on: { click: _vm.clickStatusLabel }
        },
        [
          _c(
            "div",
            { staticClass: "status-field exclude-outside-click" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showActionSelect,
                    expression: "showActionSelect"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.clickOutside,
                    expression: "clickOutside"
                  }
                ],
                ref: "customInput",
                attrs: {
                  searchable: false,
                  options: _vm.actionOptions,
                  "show-labels": false
                },
                on: {
                  close: function($event) {
                    _vm.showActionSelect = false
                  },
                  input: function($event) {
                    return _vm.actionSelected(_vm.selectedAction)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function(props) {
                      return [
                        _c(
                          "div",
                          {
                            style: {
                              color: "#fff",
                              borderRadius: "5px",
                              backgroundColor: props.option.color,
                              height: "40px",
                              lineHeight: "40px",
                              textAlign: "center"
                            }
                          },
                          [_vm._v(_vm._s(props.option.name))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selectedAction,
                  callback: function($$v) {
                    _vm.selectedAction = $$v
                  },
                  expression: "selectedAction"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "status-text" }, [
            _vm._v(_vm._s(_vm.statusText))
          ]),
          _vm._v(" "),
          _vm.deliverable.manually_updated_at
            ? _c("span", { staticClass: "unlinked-icon" }, [
                _vm.linkicon
                  ? _c("i", {
                      staticClass: "fas fa-unlink clickable",
                      on: { click: _vm.fetchDeliverableDetail }
                    })
                  : _c("i", { staticClass: "fas fa-unlink" })
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }